import React from 'react';

const MyReview = () => {
    
    return (
        <div>
            <h1>This is my review</h1>
        </div>
    );
};

export default MyReview;